import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Breakpoints, BrowserEvents, Classes } from '../global/constants';
import { mediaQueryString } from '../global/helpers';

gsap.registerPlugin(ScrollTrigger);

// ---------- Variables ----------

let animations = { global: [] };
Object.entries(Breakpoints).forEach(([breakpoint, value]) => animations[breakpoint] = { width: value, min: [], max: [] });

// ---------- Init Scroll Animation ----------

export const initScrollAnimations = () => {

	// ---------- Animated Section ----------

	$('.animated-section:not(.transition-clone)').each(function() {

		animations.global.push(() => {

			const timeline = gsap.timeline({
				scrollTrigger: {
					trigger: this,
					once: true,
					start: 'top 80%',
					toggleClass: Classes.active,
				}
			});
		});
	});

	// ---------- Content Sections ----------

	$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

		animations.mobile.min.push(() => {

			const image = this.querySelector(':scope .section-image');
			const speed = 25;

			if(image) {

				const timeline = gsap.timeline({
					scrollTrigger: {
						trigger: this,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
					},
				});

				timeline.fromTo(image, { yPercent: -speed }, { yPercent: speed, ease: 'none' });
			}
		});
	});

	// ---------- Handle Media Queries ----------

	let animationsBreakpoints = {};

	Object.entries(animations).forEach(([breakpoint, value]) => {

		if(Array.isArray(value)) {
			animationsBreakpoints['all'] = () => animations.global.map(animation => animation());
		}
		else {
			animationsBreakpoints[mediaQueryString(value.width)] = () => value.min.map(animation => animation());
			animationsBreakpoints[mediaQueryString(value.width, false)] = () => value.max.map(animation => animation());
		}
	});

	ScrollTrigger.matchMedia(animationsBreakpoints);
};

$Elements.document.on(BrowserEvents.page.enter, () => initScrollAnimations());
